const base = "TRAINER_HORSE_DETAILS_PAGE";
export const SET_PREFERRED_CONDITIONS_STATE = `${base}_SET_PREFERRED_CONDITIONS_STATE`;
export const SET_MAP_POPUP_STATE = `${base}_SET_MAP_POPUP_STATE`;

export interface ITrainerHorseDetailsPageActions {
  type: string;
  preferredConditionsState: boolean;
  mapPopupState: boolean;
}

export const setStatePreferredConditions = (
  preferredConditionsState: boolean
): Partial<ITrainerHorseDetailsPageActions> => {
  return {
    type: SET_PREFERRED_CONDITIONS_STATE,
    preferredConditionsState
  };
};

export const setMapPopupState = (
  mapPopupState: boolean
): Partial<ITrainerHorseDetailsPageActions> => {
  return {
    type: SET_MAP_POPUP_STATE,
    mapPopupState
  };
};
